import schoolsApi from '@/api/schools';

// initial state
const state = {
  schools: [],
  schoolsOnPage: { schoolCount: 0, schools: [] },
  schoolsPaging: {
    filter: null,
    page: 1,
    pageSize: 20,
    includeArchived: false,
  },
  school: {},
  licenses: [],
  usersSchool: null,
};

// getters
const getters = {
  schools: (currentState) => currentState.schools,
  pagedSchools: (currentState) => currentState.schoolsOnPage,
  schoolsPaging: (currentState) => currentState.schoolsPaging,
  school: (currentState) => currentState.school,
  usersSchool: (currentState) => currentState.usersSchool,
  licenses: (currentState) => currentState.licenses,
};

// actions
const actions = {
  getSchools({ dispatch, commit }) {
    dispatch('showLoader');
    schoolsApi.getSchools().then((response) => {
      commit('setSchools', { schools: response.data });
      dispatch('hideLoader');
    });
  },
  getPagedSchools({ dispatch, commit }, paging) {
    dispatch('showLoader');
    schoolsApi.getPagedSchools(paging).then((response) => {
      commit('setPagedSchools', { schools: response.data, paging });
      dispatch('hideLoader');
    });
  },
  getSchoolForUser({ dispatch, commit }) {
    dispatch('showLoader');
    schoolsApi.getSchoolForUser().then((response) => {
      commit('setSchoolForUser', { usersSchool: response.data });
      dispatch('hideLoader');
    });
  },
  getSchool({ dispatch, commit }, id) {
    dispatch('showLoader');
    schoolsApi.getSchool(id).then((response) => {
      commit('setSchool', { school: response.data });
      dispatch('hideLoader');
    });
  },
  getSchoolLicenses({ dispatch, commit }, request) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      schoolsApi.getSchoolLicenses(request.id, request.licenseModels).then(
        (response) => {
          // commit('setTestResult', response.data);
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  getUnpaidLicenses({ dispatch, commit }, request) {
    dispatch('showLoader');
    schoolsApi.getUnpaidLicenses(request.licenseModels).then((response) => {
      commit('setLicenses', { licenses: response.data });
      dispatch('hideLoader');
    });
  },
  getActiveLicenses({ dispatch, commit }) {
    dispatch('showLoader');
    schoolsApi.getActiveLicenses().then((response) => {
      commit('setLicenses', { licenses: response.data });
      dispatch('hideLoader');
    });
  },
  getExpiringLicenses({ dispatch, commit }) {
    dispatch('showLoader');
    schoolsApi.getExpiringLicenses().then((response) => {
      commit('setLicenses', { licenses: response.data });
      dispatch('hideLoader');
    });
  },
  getExpiredLicenses({ dispatch, commit }) {
    dispatch('showLoader');
    schoolsApi.getExpiredLicenses().then((response) => {
      commit('setLicenses', { licenses: response.data });
      dispatch('hideLoader');
    });
  },
  getPaidLicenses({ dispatch, commit }, request) {
    dispatch('showLoader');
    schoolsApi.getPaidLicenses(request).then((response) => {
      commit('setLicenses', { licenses: response.data });
      dispatch('hideLoader');
    });
  },
  createSchool({ dispatch }, school) {
    return new Promise((resolve, reject) => {
      schoolsApi.createSchool(school).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  addLicense({ dispatch }, license) {
    return new Promise((resolve, reject) => {
      schoolsApi.addLicense(license.schoolId, license).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  updateLicense({ dispatch }, license) {
    return new Promise((resolve, reject) => {
      schoolsApi.updateLicense(license.schoolId, license).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  updateStatus({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      schoolsApi.updateStatus(request.schoolId, request.status).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  removeLicense({ dispatch }, { schoolId, licenseId }) {
    return new Promise((resolve, reject) => {
      schoolsApi.removeLicense(schoolId, licenseId).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  payLicense({ dispatch }, { schoolId, licenseId, amount, date }) {
    return new Promise((resolve, reject) => {
      schoolsApi.payLicense(schoolId, licenseId, { amount, date }).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
};

// mutations
const mutations = {
  setSchools(currentState, { schools }) {
    currentState.schools = schools;
  },
  setPagedSchools(currentState, { schools, paging }) {
    currentState.schoolsOnPage = schools;
    currentState.schoolsPaging = paging;
  },
  setSchool(currentState, { school }) {
    currentState.school = school;
  },
  setSchoolForUser(currentState, { usersSchool }) {
    currentState.usersSchool = usersSchool;
  },
  setLicenses(currentState, { licenses }) {
    currentState.licenses = licenses;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/schools.js